module.exports = __webpack_public_path__ + "static/media/03.23bde729.jpg";